import { asyncAction, asyncReducer, asyncSelector } from '../utils'
import { EmployeesServiceProvider } from '../../api/employees'

const EmployeesService = EmployeesServiceProvider()
const name = 'uploadEmployeesAppend'

export default (data) => (asyncAction(
  name,
  EmployeesService.uploadEmployeesAppend,
  data
))

export const reducer = asyncReducer(name)
export const selector = asyncSelector(name)



// WEBPACK FOOTER //
// ./src/store/employee/uploadEmployeesAppend.js